import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoadingSkeleton } from './components/ui/LoadingSkeleton';
import { Card } from './components/ui/Card';
import { useAuthStore } from './stores/authStore';

const DevLoginPage = lazy(() => import('./features/auth/DevLoginPage'));
const LoginPage = lazy(() => import('./features/auth/LoginPage'));
const RegisterPage = lazy(() => import('./features/auth/RegisterPage'));
const DashboardPage = lazy(() => import('./features/dashboard/DashboardPage'));
const DebtsPage = lazy(() => import('./features/debts/DebtsPage'));
const SettingsPage = lazy(() => import('./features/settings/SettingsPage'));

function PageLoader() {
  return (
    <Card padding="lg">
      <LoadingSkeleton lines={5} />
    </Card>
  );
}

export default function App() {
  const restoreSession = useAuthStore((s) => s.restoreSession);

  useEffect(() => {
    restoreSession();
  }, [restoreSession]);
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          {import.meta.env.DEV && <Route path="/dev-login" element={<DevLoginPage />} />}

          <Route element={<ProtectedRoute />}>
            <Route
              path="/dashboard"
              element={
                <ErrorBoundary>
                  <DashboardPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/debts"
              element={
                <ErrorBoundary>
                  <DebtsPage />
                </ErrorBoundary>
              }
            />
            <Route path="/plan" element={<Navigate to="/dashboard" replace />} />
            <Route path="/check-in" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/settings"
              element={
                <ErrorBoundary>
                  <SettingsPage />
                </ErrorBoundary>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
